theme.tracker = (() => {

  function checkoutDataLayer(step, option, products) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: {
            step,
            option,
          },
          products,
        },
      },
    });
    console.log('CHECKOUT', window.dataLayer);
  }
  return {
    checkoutDataLayer,
  };
})();

export default theme.tracker;

// fire events for add to cart and cart quantity change
if (theme?.settings?.enable_tag_manager) {

  document.addEventListener('cart:removed', (e) => {
    // Shopify custom pixel event remove_from_cart
    const customData = {
      data: e.detail.product,
      currency: Shopify.currency.active,
    };

    if(customData.data.length > 1) {
      customData.data = customData.data.reduce((accumulator, item) => {
        const existingItem = accumulator.find((existing) => item.id === existing.id && item.final_price === existing.final_price && item.final_price === 0);

        if (existingItem) {
          existingItem.quantity += item.quantity;
        } else {
          accumulator.push(item);
        }

        return accumulator;
      }, []);
    }


    Shopify.analytics.publish('remove_from_cart', customData);
  });

  document.addEventListener('checkout', (e) => {
    // Shopify custom pixel event begin_checkout
    const customData = {
      data: e.detail.customData
    }
    Shopify.analytics.publish('begin_checkout', customData);
  });
}
